import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Heart } from "lucide-react";
import { toast } from "sonner";

export default function FavoriteButton({ expId, initialCount = 0, className = "" }) {
  const { user } = useAuth();
  const [fav, setFav] = useState(false);
  const [count, setCount] = useState(initialCount);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setCount(initialCount);
  }, [initialCount]);

  useEffect(() => {
    if (!user) return;
    api.get("/favorites/mine").then((r) => {
      setFav(r.data.some((e) => e.id === expId));
    }).catch((err) => { console.error("Load favorites failed", err); });
  }, [user, expId]);

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) { toast.error("Sign in to save favorites"); return; }
    if (busy) return;
    setBusy(true);
    try {
      if (fav) {
        const { data } = await api.delete(`/favorites/${expId}`);
        setFav(false); setCount(data.favorite_count);
      } else {
        const { data } = await api.post(`/favorites/${expId}`);
        setFav(true); setCount(data.favorite_count);
      }
    } catch (err) {
      console.error("Toggle favorite failed", err);
    }
    finally { setBusy(false); }
  };

  return (
    <button
      data-testid={`favorite-btn-${expId}`}
      onClick={toggle}
      className={`inline-flex items-center gap-1.5 rounded-full bg-white/90 backdrop-blur px-3 py-1.5 text-xs border border-subtle hover:border-terracotta transition-colors ${className}`}
    >
      <Heart className={`h-3.5 w-3.5 ${fav ? "fill-terracotta text-terracotta" : "text-ink"}`} strokeWidth={1.75} />
      <span className={fav ? "text-terracotta font-medium" : "text-ink"}>{count}</span>
    </button>
  );
}
